import React from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import { useState } from 'react';
import Eventmanagemntcontent from '../sections/event-mangement-main-content';


const Eventmanagement = () => {

     const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return ( 
         <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                
                        <Eventmanagemntcontent />


            </section>
    </section>
     );
}
 
export default Eventmanagement;